<svelte:options accessors/>
<script lang="ts">
    import NauiTable from "../naui/components/NauiTable.svelte";

    import {onMount, createEventDispatcher} from "svelte";

    export let data = [];
    export let _data = [];

    export let documentoLabel = 'Documento';
    export let archivoLabel = 'Archivo';
    export let categoryLabel = 'Categoría';
    export let actionsLabel = '';
    export let category = false;
    export let checkbox = true;
    export let optionGroup = null;
    export let readOnly = false;

    export let tableSchema: { [key: string]: boolean } = {
        label: true,
        archivo: true,
        category: true,
        completed: true
    }

    let fileList = {};
    let dispatch = createEventDispatcher();

    onMount(() => {
        generateTableSchema();
        runAdaptor();
    });

    let columns = [
        {
            slug: 'slug',
            label: '',
            type: 'checkbox',
            width: 'max-content',
            order: false,
        },
        {
            slug: 'label',
            label: documentoLabel,
            class: '',
            type: 'input',
            order: false
        },
        {
            slug: 'archivo',
            label: archivoLabel,
            class: '',
            type: 'text',
            order: false
        },
        {
            slug: 'category',
            label: categoryLabel,
            type: 'select',
            order: false
        },
        {
            slug: 'completed',
            label: 'Estado',
            class: '',
            type: 'icon',
            order: false
        },
        {
            slug: 'actions',
            label: actionsLabel,
            width: '160px',
            type: 'actions',
        }
    ];

    let required = ['actions'];

    function generateTableSchema() {
        columns.forEach((c: any) => {
            const find = required.find(s => s === c.slug);
            c.show = find ? true : tableSchema[c.slug];
        });
        columns = [...columns];
    }

    function runAdaptor() {
        _data = (data || []).map((x) => {
            return {
                slug: x.slug,
                label: x.label,
                archivo: getFileName(x.route),
                category: x.category,
                ref: null,
                completed: x.completed ? {
                    icon: 'check',
                    color: 'secondary',
                    iconFamily: 'far'
                } : {icon: 'horizontal-rule', iconFamily: 'fal', color: 'text-light'},
                actions: getActions(x.route)
            }
        });
    }

    export function refresh() {
        runAdaptor();
    }

    function getFileName(route) {
        if (route) {
            const folders = route.split('/');
            return folders[folders.length - 1];
        } else {
            return '';
        }
    }

    function getActions(route) {
        let response = [];
        if (route) {
            response = [
                {
                    icon: 'redo',
                    iconFamily: 'far',
                    color: 'secondary',
                    slug: 'load'
                },
                {
                    icon: 'file-download',
                    iconFamily: 'far',
                    slug: 'download',
                    route: route,
                    download: true
                },
                {
                    icon: 'trash',
                    iconFamily: 'far',
                    slug: 'remove',
                }
            ]
        } else {
            response = [
                {
                    icon: 'arrow-to-top',
                    iconFamily: 'far',
                    color: 'secondary',
                    slug: 'load',
                },
                {
                    icon: 'file-download',
                    disabled: true,
                    slug: 'download',
                    download: true
                },
                {
                    icon: 'trash',
                    disabled: false,
                    slug: 'remove',
                }
            ]
        }

        if (readOnly) {
            response = response.filter(i => i.download);
            const find = columns.find(c => c.slug === 'label');
            if (find) {
                find.type = 'text'
            }
        }
        return response;
    }

    function handleAction(ev) {
        if (ev.detail.action === 'load') {
            const item = _data.find(d => d.slug === ev.detail.slug);
            const input = item.ref;
            input.click();
        } else if (ev.detail.action === 'remove') {
            if (confirm('¿Desea eliminar este archivo?')) {
                dispatch('remove', {slug: ev.detail.slug});
            }
        }
    }

    function updateFileList(ev, slug) {
        const entry = _data.find(d => d.slug === slug);
        const files = ev.target.files;

        if (entry && files.length > 0) {
            entry.archivo = ev.target.files[0].name;
            fileList[slug] = ev.target.files[0];
            dispatch('file', {
                slug: entry.slug,
                name: entry.label || ev.target.files[0].name,
                file: ev.target.files[0]
            });
            _data = _data;
        } else {
            delete fileList[slug];
        }
        dispatch('files', fileList);
    }

    export function updateData(ev) {
        const d = data.find(x => x.slug === ev.detail.slug);
        const _d = _data.find(x => x.slug === ev.detail.slug);

        if (d) {
            d.category = ev.detail.data;
        }
        if (_d) {
            _d.category = ev.detail.data;
        }
    }
</script>
{#if _data}
    <NauiTable {columns}
               data={_data}
               total={3}
               {optionGroup}
               on:action={handleAction}
               on:checked
               on:change={updateData}/>
    <div class="file-input-list">
        {#each _data as document}
            <input type="file"
                   bind:this={document.ref}
                   on:change={(ev => {updateFileList(ev, document.slug)})}>
        {/each}
    </div>
{/if}
<style>
    .file-input-list {
        display: none;
    }
</style>
